// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__pxb38","title":"Images90_title__2AI2i","images":"Images90_images__1PS4v"};